module.exports = __webpack_public_path__ + "img/footer-logo-ko.21c76704.png";